const authActionTypes = {
  AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
  AUTH_STORE_USER_INFORMATIONS: 'AUTH_STORE_USER_INFORMATIONS',
};

export default authActionTypes;
